var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('vue-table',{attrs:{"data":_vm.data,"headers":_vm.headers,"loading":_vm.loading},on:{"change":_vm.onPagination},scopedSlots:_vm._u([{key:"index",fn:function({item}){return [_vm._v(" "+_vm._s((item.index + 1) + ((_vm.data.current_page - 1) * _vm.data.per_page))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }